import React from "react";
import './AboutCard.css'
const AboutCard = ({img, txt1, txt2}) => {
  return (
    <div className="about-card">
      <div className="about-icon-container">
        <img src={img} alt="feature-1" />
      </div>
      <p>{txt1}</p>
      <p>{txt2}</p>
    </div>
  );
};

export default AboutCard;
